import { FormBase } from 'core/components';

export default class ProductTagEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'name',
                    label: 'PRODUCT_TAG.EDIT.NAME_LABEL',
                    placeholder: 'PRODUCT_TAG.EDIT.NAME_PLACEHOLDER',
                    rules: ['string', 'required'],
                },
            ],
        };
    }
}
